
import { Component, Prop, Vue } from 'vue-property-decorator'
import InputText, { InputTextFunction } from '@/components/organisms/study/InputText.vue'
import InputNumericalFormula, {
  InputNumericalFormulaFunction,
} from '@/components/organisms/study/InputNumericalFormula.vue'
import InputJapanese, { InputJapaneseFunction } from '@/components/organisms/study/InputJapanese.vue'
import InputEnglish, { InputEnglishFunction } from '@/components/organisms/study/InputEnglish.vue'
import InputSingleChoice, { InputSingleChoiceFunction } from '@/components/organisms/study/InputSingleChoice.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 設問情報の解答欄表示
 *   入力タイプごとにコンポーネントを切り替えるためのラッパーコンポーネント
 */
@Component({
  components: {
    InputText,
    InputNumericalFormula,
    InputJapanese,
    InputEnglish,
    InputSingleChoice,
  },
})
export default class QuestionInputArea extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** テキスト入力時の処理 */
  @Prop()
  private inputText!: InputTextFunction

  /** 数式入力時の処理 */
  @Prop()
  private inputNumericalFormula!: InputNumericalFormulaFunction

  /** 日本語手書き入力時の処理 */
  @Prop()
  private inputJapanese!: InputJapaneseFunction

  /** 英語手書き入力時の処理 */
  @Prop()
  private inputEnglish!: InputEnglishFunction

  /** 択一式入力時の処理 */
  @Prop()
  private inputSingleChoice!: InputSingleChoiceFunction

  /**
   * 解答タイプに応じたコンポーネントを返す
   *
   * @returns 入力用コンポーネント名
   */
  private get componentType(): string {
    switch (this.question.answerFormatCode) {
      case StudyModel.ANSWER_FORMAT_CODE.INPUT:
        return 'InputText'
      case StudyModel.ANSWER_FORMAT_CODE.NUMERICAL_FORMULA:
        return 'InputNumericalFormula'
      case StudyModel.ANSWER_FORMAT_CODE.JAPANESE:
        return 'InputJapanese'
      case StudyModel.ANSWER_FORMAT_CODE.ENGLISH:
        return 'InputEnglish'
      case StudyModel.ANSWER_FORMAT_CODE.SINGLE_CHOICE:
        return 'InputSingleChoice'
    }
    // 一致しない場合、基本的に発生しない
    return ''
  }
}
